import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

const url = '/secure/policies/intune/deviceManagement-dataProcessorServiceForWindowsFeaturesOnboarding'

export const intuneWindowsFeaturesOnboardingApi = createApi({
  reducerPath: 'intuneWindowsFeaturesOnboarding',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getWindowsFeaturesOnboarding: builder.query({
      query: (customerId) => ({
        url,
        params: { customerId },
      }),
    }),
  }),
})

export const { useGetWindowsFeaturesOnboardingQuery, useLazyGetWindowsFeaturesOnboardingQuery } =
  intuneWindowsFeaturesOnboardingApi

export const useGetWindowsFeaturesOnboarding = () => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetWindowsFeaturesOnboardingQuery(customerId)
}
